import type { ReactNode } from 'react';

export enum SearchLinkTypes {
	RecentViews = 'RECENT_VIEWS',
	RecentSearches = 'RECENT_SEARCHES',
	PeopleAndTeams = 'PEOPLE_AND_TEAMS',
	MimicQuery = 'MIMIC_QUERY',
	GenerateAnswer = 'GENERATE_ANSWER',
	AutoSuggestion = 'AUTO_SUGGESTION',
}

export type SearchDropdownElementProps = {
	getElementIndex?: (target?: EventTarget) => number | undefined;
};

export type EventWithTarget = {
	target?: EventTarget | null;
};

export type SearchLinkProps = {
	title: string;
	description?: string | JSX.Element;
	subheading?: string | JSX.Element;
	icon: ReactNode;
	onClick: (event: EventWithTarget) => void;
	highlightedTitle?: string;
	navigationUrl?: string;
	rightPanel?: ReactNode;
	linkRef?: React.RefObject<HTMLAnchorElement>;
};
